// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  /** Text to display in the badge */
  text: string,
  /** Set the badge to success style */
  $success?: boolean,
  /** Set the badge to warning style */
  $warning?: boolean,
  /** Set the badge to error style */
  $error?: boolean,
}

const BadgeWrapper = tw.div`
  leading-5
  flex
  items-center
`

const BadgeText = tw.span`
  bg-gray-300
  text-white
  px-2
  py-1
  rounded-md
  text-xs
  font-medium
  mr-4

  ${(props: Props) => {
    if (!props.$success) return ''

    return `
      bg-green-400
      text-white
    `
  }}

  ${(props: Props) => {
    if (!props.$warning) return ''

    return `
      bg-yellow-300
      text-txt
    `
  }}

  ${(props: Props) => {
    if (!props.$error) return ''

    return `
      bg-red-400
      text-white
    `
  }}
`

/** A badge */
function Badge({ text, $success, $warning, $error }: Props): React.Node {
  return (
    <BadgeWrapper>
      <BadgeText $error={$error} $success={$success} $warning={$warning}>
        {text}
      </BadgeText>
    </BadgeWrapper>
  )
}

export default Badge
